export default __webpack_public_path__ + "static/media/hht2_ep09_timeline_q03_b.70bc4fe1.png";